import { useState } from "react";
import BookingStats from "../components/modules/bookings/BookingStats";
import BookingTabs from "../components/modules/bookings/BookingTabs";
import RequestsTable from "../components/modules/bookings/RequestsTable";
import UpcomingTable from "../components/modules/bookings/UpcomingTable";
import OrderHistoryTable from "../components/modules/bookings/OrderHistoryTable";
import JoinMeetingModal from "../components/modules/bookings/JoinMeetingModal";
import BookingDetailsModal from "../components/modules/bookings/BookingDetailsModal";
import { bookingStats, requests, upcoming, orderHistory } from "../data/bookingsData";

export default function Bookings() {
  const [activeTab, setActiveTab] = useState("requests");
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [meetingBooking, setMeetingBooking] = useState(null);

  const counts = {
    requests: requests.length,
    upcoming: upcoming.length,
    history: orderHistory.length,
  };

  return (
    <div>
      <h1 className="text-3xl font-extrabold text-gray-900">Bookings</h1>
      <p className="text-gray-600 mt-1 mb-6">
        Manage your expert consultation requests and history.
      </p>

      <BookingTabs activeTab={activeTab} setActiveTab={setActiveTab} counts={counts} />

      {activeTab !== "history" && <BookingStats stats={bookingStats} />}

      {activeTab === "requests" && (
        <RequestsTable data={requests} onView={setSelectedBooking} />
      )}

      {activeTab === "upcoming" && (
        <UpcomingTable
          data={upcoming}
          onView={setSelectedBooking}
          onJoinMeeting={setMeetingBooking}
        />
      )}

      {activeTab === "history" && <OrderHistoryTable data={orderHistory} />}

      {meetingBooking && (
        <JoinMeetingModal booking={meetingBooking} onClose={() => setMeetingBooking(null)} />
      )}

      {selectedBooking && (
        <BookingDetailsModal booking={selectedBooking} onClose={() => setSelectedBooking(null)} />
      )}
    </div>
  );
}